<template>
    <div class="client-space">
        <div id="dne"></div>
        <Header :dataSource="page" />

        <!-- HEADER STORE -->
        <div class="load" v-if="loadMerchantStore"></div>
        <HeaderStore :dataSource="dataMerchantStore" v-if="!loadMerchantStore && isMerchant" />

        <section class="client-space-home" :class="{isMerchant: isMerchant}">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-lg-6 col-welcome">
                        <div class="welcome">
                            <img src="~@/assets/images/header/dne-pay-white.svg" alt="DNE Pay">
                            <p><span>{{ getMyLanguage("ClientSpace","welcome.greeting") }} <strong>{{$store.state.profile.profile_full_name}}</strong></span></p>
                        </div>

                        <div class="download-app">
                            <img src="~@/assets/images/content/qrcode-download-app.png" alt="Download DNE App" class="qrcode">

                            <div class="stores">
                                <a href="https://play.google.com/store/apps/details?id=com.dneecosystem.app" target="_blank">
                                    <img src="~@/assets/images/icons/app-dne-download-android.svg" alt="Google Play">
                                </a>
                                
                                <a href="https://apps.apple.com/pt/app/dne-ecosystem/id6466728703" target="_blank">
                                    <img src="~@/assets/images/icons/app-dne-download-ios.svg" alt="App Store">
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-6 col-menu-client">
                        <div class="menu-client" v-if="showContent">
                            
                            <div class="customer" :class="{isMerchant: isMerchant}">
                                <div class="legend" v-if="isMerchant">
                                    <span>{{ getMyLanguage("ClientSpace","menu-client.legend.client") }}</span>
                                </div>

                                <a :href="`/${flagSelected}/client-space/wallets`" class="menu wallets">
                                    <i></i>
                                    <strong>{{ getMyLanguage("Wallets","title") }}</strong>
                                </a>

                                <a :href="`/${flagSelected}/client-space/transactions`" class="menu transactions">
                                    <i></i>
                                    <strong>{{ getMyLanguage("Transactions","title") }}</strong>
                                </a>

                                <a :href="`/${flagSelected}/client-space/dne-app`" class="menu dne-app" target="_blank">
                                    <i></i>
                                    <strong>DNE App</strong>
                                </a>

                                <div class="menu purchase-token" @click="purchaseToken()">
                                    <i></i>
                                    <strong>
                                        Comprar
                                        <span>DNE Token</span>
                                    </strong>
                                </div>

                                <div class="menu add-company" @click="addCompany()" v-if="$store.state.profile.account_type_code == 'account_type_person'">
                                    <i></i>
                                    <strong>{{ getMyLanguage("Login","my-business.add-company") }}</strong>
                                </div>
                            </div>

                            <div class="merchant" :class="{isMerchant: isMerchant}" v-if="isMerchant">
                                <div class="legend">
                                    <span>{{ getMyLanguage("ClientSpace","menu-client.legend.merchant") }}</span>
                                </div>

                                <a :href="`/${flagSelected}/merchant/sales`" class="menu sales">
                                    <i></i>
                                    <strong>{{ getMyLanguage("Sales","title") }}</strong>
                                </a>

                                <a :href="`/${flagSelected}/merchant/plugin`" class="menu plugin">
                                    <i></i>
                                    <strong>Plugin</strong>
                                </a>

                                <div class="menu company" @click="lnkCompany()">
                                    <i></i>
                                    <strong>{{ getMyLanguage("Company","title") }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="download-app">
                            <div class="stores">
                                <a href="https://play.google.com/store/apps/details?id=com.dneecosystem.app" target="_blank">
                                    <img src="~@/assets/images/icons/app-dne-download-android.svg" alt="Google Play">
                                </a>
                                
                                <a href="https://apps.apple.com/pt/app/dne-ecosystem/id6466728703" target="_blank">
                                    <img src="~@/assets/images/icons/app-dne-download-ios.svg" alt="App Store">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>



<script>
    import Header from "@/components/Header"
    import getMyContentLanguage from "@/services/contentLanguage.js";

    import apiMerchant from '@/config/apiMerchant.js'

    import HeaderStore from "@/components/HeaderStore.vue";
    import bus from '@/eventBus';

    export default{
        components: {
            Header,
            HeaderStore
        },

        data(){
            return{
                flagSelected: "en",
                showContent: false,
                page: "client-space",
                
                VUE_APP_PLATFORM_URL: process.env.VUE_APP_PLATFORM_URL,
                VUE_APP_MARKET_URL: process.env.VUE_APP_MARKET_URL,
                VUE_APP_INTERNATIONAL_URL: process.env.VUE_APP_INTERNATIONAL_URL,
                VUE_APP_PAY_URL: process.env.VUE_APP_PAY_URL,
                VUE_APP_EXCHANGE_URL: process.env.VUE_APP_EXCHANGE_URL,

                tokenAuth: localStorage.getItem('accessToken'),

                hasToken: "",
                token: "",

                dataMerchantStore: {},
                loadMerchantStore: true,

                isMerchant: false,

            }
        },

        beforeMount(){
            this.loginStatus()
        },

        async mounted() {
            this.checkLocalStorage();

            window.addEventListener("storage", this.handleStorageChange);

            this.showContent = true;

            this.waitForMerchantUpdate();
        },
        
        beforeUnmount() {
            window.removeEventListener("storage", this.handleStorageChange);
        },

        methods: {
            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code

                // document.title = this.getMyLanguage("seo","title.client-space");
                document.head.querySelector('meta[name=description]').content = ''
            },

            loginStatus(){
                if (!localStorage.getItem("accessToken")) {
                    window.location.href = "/";
                }
            },

            getMyLanguage(group, code){
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },

            lnkCompany() {
                const url = `${this.VUE_APP_MARKET_URL}${this.flagSelected}/account/token-auth?tk=${this.tokenAuth}&destiny=merchant/company/${localStorage.getItem('storeReference')}`
                window.open(url, '_blank')
            },

            purchaseToken(){
                const url = `${this.VUE_APP_INTERNATIONAL_URL}${this.flagSelected}/account/token-auth?tk=${this.tokenAuth}&destiny=client-space/purchase`
                window.open(url, '_blank')
            },
            
            addCompany() {
                const url = `${this.VUE_APP_MARKET_URL}${this.flagSelected}/account/token-auth?tk=${this.tokenAuth}&destiny=merchant/company/0`
                window.open(url, '_blank')
            },

            checkLocalStorage() {
                this.isMerchant = !!localStorage.getItem("isMerchant")

                setTimeout(() => {
                    this.loadMerchantStore = false
                }, 500);
            },

            handleStorageChange(event) {
                if (event.key === "isMerchant") {
                    this.checkLocalStorage()
                }
            },

            // HEADER STORE
            async loadHeaderStore(){
                await apiMerchant('/api/v1/market/store')
                .then(response => {
                    setTimeout(() => {
                        this.dataMerchantStore = response.data.store
                        this.loadMerchantStore = false
                    }, 500);
                })
                .catch(error => {
                    setTimeout(() => {
                        this.errorsGet.dataMerchantStore = error.response.status
                        this.loadMerchantStore = false
                        localStorage.removeItem("storeReference")

                        if ( error.response.status == 401 ){
                            bus.emit('open-login',"401");
                        }
                    }, 500);
                })
            },

            async waitForMerchantUpdate() {
                let attempts = 0;
                while (attempts < 10) {
                    if (localStorage.getItem("isMerchant")) {
                        this.isMerchant = true
                        break;
                    }

                    await new Promise(resolve => setTimeout(resolve, 200))
                    attempts++;
                }
            }
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                }
            },
            isMerchant(newValue) {
                console.log("isMerchant:", newValue);

                if ( this.isMerchant ){
                    this.loadHeaderStore()
                }
            }
        },

        created () {
            document.head.querySelector('meta[name=description]').content = ''
            document.head.querySelector('meta[name=robots]').content = 'noindex, nofollow'
        },
    }
</script>

<style src="./custom-home.scss" lang="scss" scoped />